"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_Facebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("title", null, "7F032A5C-58A1-459B-B527-1B6F846B3C52"), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3rd-party-icons",
    transform: "translate(-79.000000, -212.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons+Indicators-/-3rd-Party-Icons-/-Facebook-/-App-Launcher",
    transform: "translate(79.000000, 212.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3B5998",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Facebook",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,16 C0,7.16344357 7.16344357,0 16,0 C24.8365564,0 32,7.16344357 32,16 C32,24.8365564 24.8365564,32 16,32 C7.16344357,32 0,24.8365564 0,16 Z",
    id: "back",
    fill: "#3B5998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0573509,26.6666667 L18.0573509,15.998751 L20.9499955,15.998751 L21.3333333,12.3225282 L18.0573509,12.3225282 L18.0622654,10.4825433 C18.0622654,9.52372777 18.1517519,9.0099725 19.5044922,9.0099725 L21.3128559,9.0099725 L21.3128559,5.33333333 L18.4198017,5.33333333 C14.9447784,5.33333333 13.7216603,7.11669691 13.7216603,10.1157537 L13.7216603,12.3229445 L11.5555556,12.3229445 L11.5555556,15.9991673 L13.7216603,15.9991673 L13.7216603,26.6666667 L18.0573509,26.6666667 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))))));
}

var _default = ic_Facebook;
exports.default = _default;